(() => {
  const ROOT_SELECTOR = '[data-guru-service-contract]';

  function init(root) {
    root.guruServiceAbortController?.abort();
    const controller = new AbortController();
    root.guruServiceAbortController = controller;

    const faqSearch = root.querySelector('[data-service-faq-search]');
    if (!faqSearch) return;

    const queryInput = faqSearch.querySelector('[data-service-faq-query]');
    const clearButton = faqSearch.querySelector('[data-service-faq-clear]');
    const filterButtons = [...root.querySelectorAll('[data-service-faq-filter]')];
    const items = [...root.querySelectorAll('[data-service-faq-item]')];
    const count = root.querySelector('[data-service-faq-count]');
    const empty = root.querySelector('[data-service-faq-empty]');
    const emptyQuery = root.querySelector('[data-service-faq-empty-query]');
    const status = root.querySelector('[data-service-faq-status]');
    if (!queryInput || !clearButton || !empty || !emptyQuery || !status) return;

    const language = root.dataset.market === 'se' ? 'sv' : 'da';
    const groupedCategories = {
      delivery: ['delivery', 'recurring'],
      returns: ['returns', 'complaints'],
    };
    let activeCategory = 'all';
    const normalize = (value) => value.toLocaleLowerCase(language).normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    const update = () => {
      const query = normalize(queryInput.value.trim());
      let visible = 0;
      for (const item of items) {
        const categories = groupedCategories[activeCategory] || [activeCategory];
        const categoryMatch = activeCategory === 'all' || categories.includes(item.dataset.category);
        const queryMatch = !query || normalize(item.textContent).includes(query);
        item.hidden = !(categoryMatch && queryMatch);
        if (!item.hidden) visible += 1;
      }
      if (count) count.textContent = String(visible);
      empty.hidden = visible !== 0;
      emptyQuery.textContent = queryInput.value.trim() || (language === 'sv' ? 'din sökning' : 'din søgning');
      clearButton.hidden = !queryInput.value;
      status.textContent = language === 'sv' ? `${visible} svar visas.` : `${visible} svar vises.`;
    };

    faqSearch.addEventListener('submit', (event) => event.preventDefault(), { signal: controller.signal });
    queryInput.addEventListener('input', update, { signal: controller.signal });
    clearButton.addEventListener('click', () => {
      queryInput.value = '';
      queryInput.focus();
      update();
    }, { signal: controller.signal });
    for (const button of filterButtons) {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.serviceFaqFilter;
        for (const candidate of filterButtons) candidate.setAttribute('aria-pressed', String(candidate === button));
        update();
      }, { signal: controller.signal });
    }

    const initialQuery = new URLSearchParams(window.location.search).get('q');
    if (initialQuery) queryInput.value = initialQuery;
    update();
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(init);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach((root) => root.guruServiceAbortController?.abort());
  });
})();
